'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base Page Management
 * @extends BasePieceController
 *
 * @lint global BasePageController
 */
window.BasePageController = function (_BasePieceController) {
  _inherits(BasePageController, _BasePieceController);

  /**
   * Class constructor.
   * @param {string} name DOM element identifier.
   */
  function BasePageController() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, BasePageController);

    return _possibleConstructorReturn(this, (BasePageController.__proto__ || Object.getPrototypeOf(BasePageController)).call(this, '.page-', name));
  }

  /**
   * Initialize data binding for this element.
   * @param {object} data Data to bind in DOM
   * @param {boolean} scoped Scope binding to this DOM element.
   */


  _createClass(BasePageController, [{
    key: 'bindData',
    value: function bindData(data) {
      var scoped = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


      var pageData = new PageModel(data);

      this.binder.apply(pageData, scoped ? this.dom : undefined);

      this.initBehaviour();
    }
  }]);

  return BasePageController;
}(BasePieceController);